<template>
  <div :key="componentKey">
 <div class="p-t-30 boxConcordata">
   <v-flex>
     <v-layout row wrap class p-b-20>
       <v-flex p-t-30>
         <div class="tituloBox p-b-30 border-top">
           <div class="bg-primary barraTitulo"></div>
           <h1 class="text-info font-size-18">
             <strong>{{ $t('label.concordataEFalencia') }}</strong>
           </h1>
         </div>
       </v-flex>
     </v-layout>
     <v-layout row wrap class p-b-20>
       <v-flex xs12>
         <v-card>
           <v-layout row wrap>
             <v-flex xs12 sm4 md4>
               <v-text-field v-model="modelQualificacao.concordataFalencia.numDocumento"
                 :label="$t('label.numeroDocumento') + testeAstericoEstrangeiro()"
                 :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]" required
                 validate-on-blur
                 :hint="ifConcordataFalenciaAlterado(modelQualificacao.concordataFalencia.numDocumento, 'numDocumento')"
                 persistent-hint maxlength="30" v-mask="maskDocumentoIdentificacaoUpload"
                 @change="alteracaoValorCampoConcordata(modelQualificacao.concordataFalencia)"></v-text-field>
             </v-flex>

             <v-flex xs6 sm4 md2>
               <datePicker v-model="modelQualificacao.concordataFalencia.dtEmissao"
                 :dataDefault="model.concordataFalencia.dtEmissao" v-mask="maskData" :limitarData="true"
                 :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio'), v => validaDataInvalida(v) || 'Data Inválida']"
                 :label="$t('label.dataEmissao') + testeAstericoEstrangeiro()" required validate-on-blur
                 @change="alteracaoValorCampoConcordata()"
                 :hint="ifConcordataFalenciaAlterado(modelQualificacao.concordataFalencia.dtEmissao, 'dtEmissao', true)"
                 persistent-hint />
             </v-flex>

             <v-flex xs6 sm4 md2>
               <datePicker v-model="modelQualificacao.concordataFalencia.dtVencimento"
                 :dataDefault="model.concordataFalencia.dtVencimento" v-mask="maskData"
                 :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio'), v => validaDataInvalida(v) || 'Data Inválida']"
                 :label="$t('label.dataValidade') + testeAstericoEstrangeiro()" required validate-on-blur
                 @change="alteracaoValorCampoConcordata()"
                 :hint="ifConcordataFalenciaAlterado(modelQualificacao.concordataFalencia.dtVencimento, 'dtVencimento', true)"
                 persistent-hint />
             </v-flex>
             <v-flex xs12 sm6 md4>
               <v-select v-model="modelQualificacao.concordataFalencia.situacaoDoc" :items="enums.situacaoDoc"
                 :label="$t('label.situacao') + testeAstericoEstrangeiro()" item-text="descricao" item-value="valor"
                 :return-object="false" @change="alteracaoValorCampoConcordata()"
                 :rules="[v => validaIfObrigatorioSit(v, 'situacaoDoc') || $t('messages.validacao.campoObrigatorio')]"
                 validate-on-blur
                 :hint="ifConcordataFalenciaAlterado(modelQualificacao.concordataFalencia.situacaoDoc, 'situacaoDoc')"
                 persistent-hint>
               </v-select>
             </v-flex>

             <v-flex xs12 sm6 md5>
               <v-text-field v-model="modelQualificacao.concordataFalencia.codControle" maxlength="50"
                 :label="$t('label.codDeControle')" @change="alteracaoValorCampoConcordata()"
                 :hint="ifConcordataFalenciaAlterado(modelQualificacao.concordataFalencia.codControle, 'codControle')"
                 persistent-hint>
               </v-text-field>
             </v-flex>

             <v-flex inputIcon xs12 sm12 md7 v-show="!modelQualificacao.concordataFalencia.novoUpload">
               <textFieldValidadorDelete :arquivoUpload="model.concordataFalencia.arquivoUpload"
                 :arquivoUploadSituacao="model.concordataFalencia.arquivoUploadSituacao"
                 :idMotivoIndeferimentoArquivo="model.concordataFalencia.idMotivoIndeferimentoArquivo"
                 :codDocumento="model.concordataFalencia.codDocumentoSIMPAS" :idFornecedor="model.numCgcFornecedor"
                 v-on:clear="iconDelete(model.concordataFalencia, 'concordata')" 
                 v-on:aprovar="validarCampo(2, 'c')"
                 v-on:rejeitar="validarCampo(1, 'c', $event)"
                 :label="$t('label.anexaDocumento') + testeAstericoEstrangeiro()" clearable
                 :hint="ifConcordataFalenciaAlterado(modelQualificacao.concordataFalencia.arquivoUpload, 'arquivoUpload')"
                 persistent-hint>
               </textFieldValidadorDelete>
             </v-flex>
             <v-flex xs12 sm12 md7 v-show="modelQualificacao.concordataFalencia.novoUpload">
               <uploadFile tamanhoMaximo="20MB" :required="!(model.tipoCertificado == 2 && (model.tipFornecedor == 'J' || model.tipFornecedor == 'F')) &&
                 modelQualificacao.concordataFalencia.novoUpload
                 && (this.model.flagEstrangeiro === '0')"
                 :label="$t('label.anexaDocumento') + testeAstericoEstrangeiro()"
                 v-model="modelQualificacao.concordataFalencia.file" accept=".pdf, .PDF" />
             </v-flex>
           </v-layout>
         </v-card>
       </v-flex>
     </v-layout>

     <!--  Bloco título, bullet e select ano balanço 01 -->
     <div row wrap v-if="model.tipFornecedor == 'J'">
       <v-flex p-t-30>
         <div class="border-top"></div>
         <div class="bg-primary barraTitulo"></div>  
         <h1 class="text-info font-size-18 d-flex align-center titH1">        
           <strong class="titBalanco">{{ $t('label.balanco1') }}</strong>
         </h1>      
       </v-flex>

       <v-layout row wrap class="p-b-20 justify-space-between">
         <v-flex xs12 sm4 md4 um>
           <div class="divToolTip">
             <v-tooltip right color="#fff">
               <template v-slot:activator="{ on, attrs }">
                 <v-icon color="primary" class="positionBullet" v-on="on" v-bind="attrs" light>info</v-icon>
               </template>

               <v-card class="boxInfoDoc">
                 <v-list-tile-content>
                   <v-flex xs12 pb-1>
                     <strong class="text-primary">
                       Prezado Fornecedor,<br /><br />
                       Em atendimento a IN RFB nº 2142/2023 a ECD deve ser transmitida ao Sistema Público de Escrituração Digital (SPED)
                       até o último dia útil do mês de junho do ano subsequente ao ano calendário a que se refere à escrituração.
                     </strong>
                   </v-flex>
                 </v-list-tile-content>
               </v-card>
             </v-tooltip>
           </div>
         </v-flex>
         <v-flex xs12 sm4 md4 text-right dois>
           <v-combobox
            v-model="modelQualificacao.balancoFinanceiro.anoBalanco"            
            :items="anos"
            :label="$t('label.anoBalanco')"
            item-text="ano"
            class="ml-2"
            @change="MudarBalanco1Para2()"
            :rules="[
              v => validaAnoValido(v,1) || 'O ano informado está incompleto ou errado. Favor inserir os quatro dígitos.'
            ]"
          ></v-combobox> 
         </v-flex>
       </v-layout>
     </div>
     <!-- / Bloco título, bullet e select ano balanço 01 -->



     <v-flex p-b-20 v-if="model.tipFornecedor == 'J'">
       <v-card>
         <v-layout row wrap p-b-10>
           <v-flex xs12 sm6 md5>
             <v-text-field :label="$t('label.numLivroDiario') + testeAstericoEstrangeiro()"
               v-model="modelQualificacao.balancoFinanceiro.numLivroDiario"
               :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]" required maxlength="10"
               validate-on-blur @change="alteracaoValorCampoBalanco()"
               :hint="ifBalancoFinanceiroAlterado(modelQualificacao.balancoFinanceiro.numLivroDiario, 'numLivroDiario')"
               persistent-hint>
             </v-text-field>
           </v-flex>

           <v-flex inputIcon xs12 sm12 md7 v-show="!modelQualificacao.balancoFinanceiro.novoUpload">
              <!-- carlos -->
              <!-- balanço 01 -->
              <textFieldValidadorDelete :arquivoUpload="modelQualificacao.balancoFinanceiro.arquivoUpload"
                :arquivoUploadSituacao="model.balancoFinanceiro.arquivoUploadSituacao"              
                :idMotivoIndeferimentoArquivo="model.balancoFinanceiro.idMotivoIndeferimentoArquivo"
                :codDocumento="model.balancoFinanceiro.codDocumentoSIMPAS" :idFornecedor="model.numCgcFornecedor"                
                v-on:clear="iconDelete(model.balancoFinanceiro, 'balanco')" 
                v-on:aprovar="validarCampo(2, 'b')"
                v-on:rejeitar="validarCampo(1, 'b', $event)" :label="$t('label.anexaDocumento') + testeAstericoEstrangeiro()"
                clearable
                :hint="ifBalancoFinanceiroAlterado(modelQualificacao.balancoFinanceiro.arquivoUpload, 'arquivoUpload')"
                persistent-hint>
              </textFieldValidadorDelete>
           </v-flex>
           <v-flex xs12 sm12 md6 v-show="modelQualificacao.balancoFinanceiro.novoUpload">            
             <uploadFile tamanhoMaximo="20MB"
               :required="!(model.tipoCertificado == 2 && model.tipFornecedor == 'J') && (this.model.flagEstrangeiro === '0') && modelQualificacao.balancoFinanceiro.novoUpload"
               :label="$t('label.anexaDocumento') + testeAstericoEstrangeiro()"
               v-model="modelQualificacao.balancoFinanceiro.file" accept=".pdf, .PDF" />
           </v-flex>

           <v-flex xs12 sm6 md6>
             <datePicker v-model="modelQualificacao.balancoFinanceiro.dtBalanco"
               :dataDefault="model.balancoFinanceiro.dtBalanco" v-mask="maskData" :limitarData="true" :rules="[
                 v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio'),
                 v => validaDataInvalida(v) || 'Data Inválida',
                 v => validaAnoAnterior(v, 1) || 'O ano informado deve ser do ano anterior ao vigente'
               ]" :label="$t('label.dataDoBalanco') + testeAstericoEstrangeiro()" required validate-on-blur
               ref="dtBalanco"
               @input="atualizarBalancoPrincipal(false)"
               @change="alteracaoValorCampoBalanco()"
               :hint="ifBalancoFinanceiroDataAlterado(modelQualificacao.balancoFinanceiro.dtBalanco, 'dtBalanco')"
               persistent-hint />
           </v-flex>
           <v-flex xs12 sm6 md6>
             <!--
             <datePicker v-model="modelQualificacao.balancoFinanceiro.dtValidadeBalanco"
               :dataDefault="model.balancoFinanceiro.dtValidadeBalanco" v-mask="maskData" :limitarData="false"
               :rules="[v => validaIfObrigatorioDtBalanco(v) || $t('messages.validacao.campoObrigatorio'), validaDataValidade(modelQualificacao.balancoFinanceiro.dtValidadeBalanco) || 'Data Inválida']"
               :label="$t('label.dataValidadeDoBalanco') + testeAstericoDtBalanco()" required validate-on-blur
               @change="alteracaoValorCampoBalanco()"
               :hint="ifBalancoFinanceiroDataAlterado(modelQualificacao.balancoFinanceiro.dtValidadeBalanco, 'dtValidadeBalanco')"
               persistent-hint />
             -->            
             <!-- Ticket #188855 - Ajustes Data de Vencimento Balanços 01 e 02 -->
             <datePicker 
               v-model="modelQualificacao.balancoFinanceiro.dtValidadeBalanco" 
                :dataDefault="model.balancoFinanceiro.dtValidadeBalanco"
                ref="dtValidadeBalanco"
               v-mask="maskData" :limitarData="false"
               :rules="[v => validaIfObrigatorioDtBalanco(v) || $t('messages.validacao.campoObrigatorio'), validaDataValidade(modelQualificacao.balancoFinanceiro.dtValidadeBalanco) || 'Data Inválida']"
               :label="$t('label.dataValidadeDoBalanco') + testeAstericoDtBalanco()" required validate-on-blur
               @change="alteracaoValorCampoBalanco()"
               :hint="ifBalancoFinanceiroDataAlterado(modelQualificacao.balancoFinanceiro.dtValidadeBalanco, 'dtValidadeBalanco')"
               persistent-hint 
             />
             <!-- Fim Ticket #188855 - Ajustes Data de Vencimento Balanços 01 e 02 -->
           </v-flex>
         </v-layout>
       </v-card>
     </v-flex>

     <v-layout row wrap v-if="model.tipFornecedor == 'J'">
       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{ $t('label.ativo') }}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="ativoShow = !ativoShow">
                   <v-icon>{{ !ativoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="ativoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda :label="$t('label.ativoCirculante') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.ativoCirculante"
                   :valorDefault="modelQualificacao.balancoFinanceiro.ativoCirculante" required
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.ativoCirculante, 'ativoCirculante')"
                 
                   persistent-hint />
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.ativoNaoCirculante') }}:
                     <strong>{{ formatarNumero(ativoNaoCirculante) }}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.realizavelALongoPrazo') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.realizavelLP"
                   :valorDefault="modelQualificacao.balancoFinanceiro.realizavelLP" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.realizavelLP, 'realizavelLP')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.investimento') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.investimento"
                   :valorDefault="modelQualificacao.balancoFinanceiro.investimento" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.investimento, 'investimento')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.imobilizado') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.imobilizado"
                   :valorDefault="modelQualificacao.balancoFinanceiro.imobilizado" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.imobilizado, 'imobilizado')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.intangivel') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.intangivel"
                   :valorDefault="modelQualificacao.balancoFinanceiro.intangivel" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.intangivel, 'intangivel')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.ativoTotal') }}:
                     <strong>{{ formatarNumero(ativoTotal) }}</strong>
                     <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(ativoTotal, 'ativoTotal')">
                     </div>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{ $t('label.passivo') }}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="passivoShow = !passivoShow">
                   <v-icon>{{ !passivoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="passivoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda :label="$t('label.passivoCirculante') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.passivoCirculante"
                   :valorDefault="modelQualificacao.balancoFinanceiro.passivoCirculante" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.passivoCirculante, 'passivoCirculante')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.passivoNaoCirculante') }}:
                     <strong>{{ formatarNumero(passivoNaoCirculante) }}</strong>
                     <div class="hintClass"
                       v-html="ifBalancoFinanceiroMoedaAlterado(passivoNaoCirculante, 'passivoNaoCirculante')">
                     </div>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm5 md5>
                 <mascaraMoeda :label="$t('label.exigivelALongoPrazo') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.exigivelLP"
                   :valorDefault="modelQualificacao.balancoFinanceiro.exigivelLP" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.exigivelLP, 'exigivelLP')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm7 md7>
                 <mascaraMoeda :label="$t('label.resultadoDeExerciciosFuturos') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.resultExerciciosFut"
                   :valorDefault="modelQualificacao.balancoFinanceiro.resultExerciciosFut" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.resultExerciciosFut, 'resultExerciciosFut')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12>
                 <mascaraMoeda :label="$t('label.patrimonioLiquido') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.patrimonioLiquido"
                   :valorDefault="modelQualificacao.balancoFinanceiro.patrimonioLiquido" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.patrimonioLiquido, 'patrimonioLiquido')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.passivoTotal') }}:
                     <strong>{{ formatarNumero(passivoTotal) }}</strong>
                     <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(passivoTotal, 'passivoTotal')">
                     </div>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>
       <v-flex xs12 md12 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{ $t('label.receita') }}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="receitaShow = !receitaShow">
                   <v-icon>{{ !receitaShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           
           <v-slide-y-transition>
             <v-layout row wrap v-show="receitaShow" p-b-10>
               <v-flex xs12 sm4 md4>
                 <mascaraMoeda :label="$t('label.capitalSocial') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.capitalSocial"
                   :valorDefault="modelQualificacao.balancoFinanceiro.capitalSocial" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.capitalSocial, 'capitalSocial')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda :label="$t('label.receitaOperacionalLiquida') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeLiquido"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeLiquido" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.receitaOpeLiquido, 'receitaOpeLiquido')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda :label="$t('label.receitaOperacionalBruta') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeBruto"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeBruto" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.receitaOpeBruto, 'receitaOpeBruto')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md12 p-l-none p-r-none>
         <v-layout row wrap>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>

                 {{ $t('label.mediaFinanceira') }}:
                 <strong>{{ formatarNumero(mediaFinanceira) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(mediaFinanceira, 'mediaFinanceira')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.liquidezCorrente') }}:
                 <strong>{{ formatarNumero(liquidezCorrente) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(liquidezCorrente, 'liquidezCorrente')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.liquidezGeral') }}:
                 <strong>{{ formatarNumero(liquidezGeral) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(liquidezGeral, 'liquidezGeral')"></div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.solvenciaGeral') }}:
                 <strong>{{ formatarNumero(solvenciaGeral) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(solvenciaGeral, 'solvenciaGeral')"></div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.produtividade') }}:
                 <strong>{{ formatarNumero(produtividade) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(produtividade, 'produtividade')"></div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.endividamento') }}:
                 <strong>{{ formatarNumero(endividamento) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(endividamento, 'endividamento')"></div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.imobilizacaoCapitalProprio') }}:
                 <strong>{{ formatarNumero(imobilizacaoCapitalProprio, true) }}</strong>
                 <div class="hintClass"
                   v-html="ifBalancoFinanceiroMoedaAlterado(imobilizacaoCapitalProprio, 'imobilizacaoCapitalProprio')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.capitalizacao') }}:
                 <strong>{{ formatarNumero(capitalizacao, true) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(capitalizacao, 'capitalizacao')"></div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
         </v-layout>
       </v-flex>
     </v-layout>

     
      <!--  Bloco título, bullet e select ano balanço 02 -->
     <div row wrap v-if="model.tipFornecedor == 'J' && this.model.tipoCertificado === 1 &&  obrigarBalanco2() != 'semBalanco2'"  >      
       <v-flex p-t-30>
         <div class="border-top"></div>
         <div class="bg-primary barraTitulo"></div>  
         <h1 class="text-info font-size-18 d-flex align-center titH1">        
           <strong class="titBalanco">{{ $t('label.balanco2') }}</strong>
         </h1>      
       </v-flex>

       <v-layout row wrap class="p-b-20 justify-space-between">
         <v-flex xs12 sm4 md4 um>
           <div class="divToolTip">
             <v-tooltip right color="#fff">
               <template v-slot:activator="{ on, attrs }">
                 <v-icon color="primary" class="positionBullet" v-on="on" v-bind="attrs" light>info</v-icon>
               </template>

               <v-card class="boxInfoDoc">
                 <v-list-tile-content>
                   <v-flex xs12 pb-1>
                     <strong class="text-primary">Prezado Fornecedor,<br /><br />
                         Considerando que no Balanço 01 serão registrados os dados conforme IN RFB nº 2142/2023, as informações que deverão 
                         ser preenchidas no Balanço 02 referem-se ao ano anterior ao ano registrado no Balanço 01.
                     </strong>
                   </v-flex>
                 </v-list-tile-content>
               </v-card>
             </v-tooltip>
           </div>
         </v-flex>
         <v-flex xs12 sm4 md4 text-right dois>
           <v-combobox
            v-model="modelQualificacao.balancoFinanceiro.anoBalanco2"            
            :items="anos2"
            :label="$t('label.anoBalanco2')"
            item-text="ano"
            class="ml-2"
            ref="anoBalanco2"
            @change="atualizarDtValidadeBalanco2(false)"
            :rules="[
              v => validaAnoValido(v,2) || 'O ano informado está incompleto ou errado. Favor inserir os quatro dígitos.'
            ]"
          ></v-combobox>
         </v-flex>
       </v-layout>
     </div>
     <!-- / Bloco título, bullet e select ano balanço 02 -->
     

     <v-flex p-b-20 v-if="model.tipFornecedor == 'J' && obrigaBalanco2 != 'semBalanco2'">
       <v-card>
         <v-layout row wrap p-b-10>
           <v-flex xs12 sm6 md5>
             <v-text-field :label="$t('label.numLivroDiario') + testeAstericoEstrangeiro()"
               v-model="modelQualificacao.balancoFinanceiro.numLivroDiario02" :rules="[
                 () => this.obrigarBalanco2() !== 'obrigabalanco2' || !!modelQualificacao.balancoFinanceiro.numLivroDiario02 || $t('messages.validacao.campoObrigatorio')
               ]" :required="this.obrigarBalanco2() === 'obrigabalanco2'" maxlength="10" validate-on-blur
               @change="alteracaoValorCampoBalanco2()"
               :hint="ifBalancoFinanceiroAlterado(modelQualificacao.balancoFinanceiro.numLivroDiario02, 'numLivroDiario02')"
               persistent-hint>
             </v-text-field>
           </v-flex>

           <v-flex inputIcon xs12 sm12 md7 v-show="!modelQualificacao.balancoFinanceiro.novoUpload02">
             <textFieldValidadorDelete :arquivoUpload="model.balancoFinanceiro.arquivoUpload02"
               :arquivoUploadSituacao="model.balancoFinanceiro.arquivoUploadSituacao02"
               :idMotivoIndeferimentoArquivo="model.balancoFinanceiro.idMotivoIndeferimentoArquivo02"
               :codDocumento="model.balancoFinanceiro.codDocumentoSIMPAS02" :idFornecedor="model.numCgcFornecedor"               
               v-on:clear="iconDelete(model.balancoFinanceiro, 'balanco2')" 
               v-on:aprovar="validarCampo(2, 'b2')"
               v-on:rejeitar="validarCampo(1, 'b2', $event)" :label="$t('label.anexaDocumento') + testeAstericoEstrangeiro()"
               clearable
               :hint="ifBalancoFinanceiroAlterado(modelQualificacao.balancoFinanceiro.arquivoUpload02, 'arquivoUpload02')"
               
               persistent-hint>
             </textFieldValidadorDelete>
           </v-flex>
           <v-flex xs12 sm12 md6 v-show="modelQualificacao.balancoFinanceiro.novoUpload02">
             <uploadFile tamanhoMaximo="20MB"
               :required="this.obrigarBalanco2() === 'obrigabalanco2' && modelQualificacao.balancoFinanceiro.arquivoUpload02 == null"
               :label="$t('label.anexaDocumento') + testeAstericoEstrangeiro()"
               v-model="modelQualificacao.balancoFinanceiro.file02" accept=".pdf, .PDF" />
           </v-flex>

           <v-flex xs12 sm6 md6>
             <datePicker v-model="modelQualificacao.balancoFinanceiro.dtBalanco02"
                 ref="dtBalanco02"
               :dataDefault="model.balancoFinanceiro.dtBalanco02" v-mask="maskData" :limitarData="true" :rules="[
                 v => validaIfObrigatorioBalanco2(v) || $t('messages.validacao.campoObrigatorio'),
                 v => validaDataInvalidaBalanco2(v) || 'Data Inválida',
                 v => validaAnoAnterior(v, 2) || 'O ano informado deve ser 2 anos anteriores ao vigente'
               ]" :label="$t('label.dataDoBalanco') + testeAstericoEstrangeiro()" required validate-on-blur
               @change="alteracaoValorCampoBalanco2()"
               @input="atualizarBalancoSecundario(false)"
               :hint="ifBalancoFinanceiroDataAlterado(modelQualificacao.balancoFinanceiro.dtBalanco02, 'dtBalanco02')"
               persistent-hint />
           </v-flex>
           <v-flex xs12 sm6 md6>
           <datePicker  
               v-model="modelQualificacao.balancoFinanceiro.dtValidadeBalanco02" 
                :dataDefault="model.balancoFinanceiro.dtValidadeBalanco02"
                ref="dtValidadeBalanco02"
               v-mask="maskData" :limitarData="false"
               :rules="[v => validaIfObrigatorioDtValidadeBalanco2(v) || $t('messages.validacao.campoObrigatorio'), validaDataValidade(modelQualificacao.balancoFinanceiro.dtValidadeBalanco02) || 'Data Inválida']"
               :label="$t('label.dataValidadeDoBalanco') + testeAstericoDtBalanco()" required validate-on-blur
               @change="alteracaoValorCampoBalanco2()"
               :hint="ifBalancoFinanceiroDataAlterado(modelQualificacao.balancoFinanceiro.dtValidadeBalanco02, 'dtValidadeBalanco02')"
               persistent-hint 
             />
           </v-flex>
         </v-layout>
       </v-card>
     </v-flex>

     <v-layout row wrap v-if="model.tipFornecedor == 'J' && obrigaBalanco2 != 'semBalanco2'">
       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{ $t('label.ativo') }}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="ativoShow = !ativoShow">
                   <v-icon>{{ !ativoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="ativoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda :label="$t('label.ativoCirculante') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.ativoCirculante02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.ativoCirculante02" required
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.ativoCirculante02, 'ativoCirculante02')"
                   
                   persistent-hint />
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.ativoNaoCirculante') }}:
                     <strong>{{ formatarNumero(ativoNaoCirculante02) }}</strong>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.realizavelALongoPrazo') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.realizavelLP02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.realizavelLP02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.realizavelLP02, 'realizavelLP02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.investimento') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.investimento02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.investimento02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.investimento02, 'investimento02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.imobilizado') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.imobilizado02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.imobilizado02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.imobilizado02, 'imobilizado02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm6 md6>
                 <mascaraMoeda :label="$t('label.intangivel') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.intangivel02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.intangivel02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.intangivel02, 'intangivel02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.ativoTotal') }}:
                     <strong>{{ formatarNumero(ativoTotal02) }}</strong>
                     <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(ativoTotal02, 'ativoTotal02')">
                     </div>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md6 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{ $t('label.passivo') }}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="passivoShow = !passivoShow">
                   <v-icon>{{ !passivoShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="passivoShow" p-b-10>
               <v-flex xs12 sm12 md12>
                 <mascaraMoeda :label="$t('label.passivoCirculante') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.passivoCirculante02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.passivoCirculante02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.passivoCirculante02, 'passivoCirculante02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.passivoNaoCirculante') }}:
                     <strong>{{ formatarNumero(passivoNaoCirculante02) }}</strong>
                     <div class="hintClass"
                       v-html="ifBalancoFinanceiroMoedaAlterado(passivoNaoCirculante02, 'passivoNaoCirculante02')">
                     </div>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>

               <v-flex xs12 sm5 md5>
                 <mascaraMoeda :label="$t('label.exigivelALongoPrazo') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.exigivelLP02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.exigivelLP02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.exigivelLP02, 'exigivelLP02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm7 md7>
                 <mascaraMoeda :label="$t('label.resultadoDeExerciciosFuturos') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.resultExerciciosFut02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.resultExerciciosFut02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.resultExerciciosFut02, 'resultExerciciosFut02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12>
                 <mascaraMoeda :label="$t('label.patrimonioLiquido') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.patrimonioLiquido02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.patrimonioLiquido02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.patrimonioLiquido02, 'patrimonioLiquido02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm12 md12 class="p-b-10">
                 <v-toolbar light>
                   <v-toolbar-title>
                     {{ $t('label.passivoTotal') }}:
                     <strong>{{ formatarNumero(passivoTotal02) }}</strong>
                     <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(passivoTotal02, 'passivoTotal02')">
                     </div>
                   </v-toolbar-title>
                   <v-spacer></v-spacer>
                 </v-toolbar>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>
       <v-flex xs12 md12 p-b-10>
         <v-card class="boxShadow">
           <v-card-title primary-title class="p-b-none">
             <v-layout row>
               <v-flex left>
                 <div>
                   <strong class="text-primary">{{ $t('label.receita') }}</strong>
                 </div>
               </v-flex>
               <v-flex right text-xs-right>
                 <v-btn icon @click="receitaShow = !receitaShow">
                   <v-icon>{{ !receitaShow ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                 </v-btn>
               </v-flex>
             </v-layout>
           </v-card-title>

           <v-slide-y-transition>
             <v-layout row wrap v-show="receitaShow" p-b-10>
               <v-flex xs12 sm4 md4>
                 <mascaraMoeda :label="$t('label.capitalSocial') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.capitalSocial02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.capitalSocial02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.capitalSocial02, 'capitalSocial02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda :label="$t('label.receitaOperacionalLiquida') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeLiquido02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeLiquido02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.receitaOpeLiquido02, 'receitaOpeLiquido02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>

               <v-flex xs12 sm4 md4>
                 <mascaraMoeda :label="$t('label.receitaOperacionalBruta') + testeAstericoEstrangeiro()"
                   :rules="[v => validaIfObrigatorio(v) || $t('messages.validacao.campoObrigatorio')]"
                   v-model="modelQualificacao.balancoFinanceiro.receitaOpeBruto02"
                   :valorDefault="modelQualificacao.balancoFinanceiro.receitaOpeBruto02" required validate-on-blur
                   :hint="ifBalancoFinanceiroMoedaAlterado(modelQualificacao.balancoFinanceiro.receitaOpeBruto02, 'receitaOpeBruto02')"
                   persistent-hint>
                 </mascaraMoeda>
               </v-flex>
             </v-layout>
           </v-slide-y-transition>
         </v-card>
         <div class="p-b-10"></div>
       </v-flex>

       <v-flex xs12 md12 p-l-none p-r-none>
         <v-layout row wrap>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>

                 {{ $t('label.mediaFinanceira') }}:
                 <strong>{{ formatarNumero(mediaFinanceira02) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(mediaFinanceira02, 'mediaFinanceira02')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.liquidezCorrente') }}:
                 <strong>{{ formatarNumero(liquidezCorrente02) }}</strong>
                 <div class="hintClass"
                   v-html="ifBalancoFinanceiroMoedaAlterado(liquidezCorrente02, 'liquidezCorrente02')"></div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.liquidezGeral') }}:
                 <strong>{{ formatarNumero(liquidezGeral02) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(liquidezGeral02, 'liquidezGeral02')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.solvenciaGeral') }}:
                 <strong>{{ formatarNumero(solvenciaGeral02) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(solvenciaGeral02, 'solvenciaGeral02')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.produtividade') }}:
                 <strong>{{ formatarNumero(produtividade02) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(produtividade02, 'produtividade02')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.endividamento') }}:
                 <strong>{{ formatarNumero(endividamento02) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(endividamento02, 'endividamento02')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.imobilizacaoCapitalProprio') }}:
                 <strong>{{ formatarNumero(imobilizacaoCapitalProprio02, true) }}</strong>
                 <div class="hintClass"
                   v-html="ifBalancoFinanceiroMoedaAlterado(imobilizacaoCapitalProprio02, 'imobilizacaoCapitalProprio02')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>
           <v-flex xs4 sm4 md4 class="p-b-20">
             <v-toolbar light>
               <v-toolbar-title>
                 {{ $t('label.capitalizacao') }}:
                 <strong>{{ formatarNumero(capitalizacao02, true) }}</strong>
                 <div class="hintClass" v-html="ifBalancoFinanceiroMoedaAlterado(capitalizacao02, 'capitalizacao02')">
                 </div>
               </v-toolbar-title>
               <v-spacer></v-spacer>
             </v-toolbar>
           </v-flex>

           <v-dialog v-model="dialog" max-width="355" :persistent="persistent">
             <v-card>
               <v-card-title class="headline">Atenção!</v-card-title>
               <v-form>
                 <v-layout row wrap>
                   <v-flex xs12><br />
                     Deseja excluir o documento?
                   </v-flex>
                 </v-layout><br /><br />
                 <v-layout wrap p-b-10>
                   <v-flex xs12 sm6>
                     <v-btn @click="cancelarDialog()">Não</v-btn>
                   </v-flex>
                   <v-flex xs12 sm6>
                     <v-btn color="info" @click="limparAnexo(TipoDelete)" :loading="isLoading">Sim</v-btn>
                   </v-flex>
                 </v-layout>
               </v-form>
             </v-card>
           </v-dialog>

         </v-layout>
       </v-flex>
     </v-layout>
   </v-flex>
 </div>
</div>
</template>

<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import moment from 'moment';
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import qualificacaoEconomicaService from "../../../services/qualificacaoEconomicaService";
import analiseCampoAlterado from "./components/analiseCampoAlterado";

export default {
 name: "qualificacao-economica",
 props: {//Propriedades que o objeto recebe como parametro
   model: Object, /*Solicitacao atual do Fornecedor*/
   enums: Object,
   modelQualificacao: Object,
   pontuacaoIndices: Array,
   totaisContas: Object,
   refreshQualificacao: Number,
   OldModel: Object
 },
 mixins: [util, analiseCampoAlterado],

 mounted() {
  setTimeout(() => {
    this.atualizarDtValidadeBalanco(true);
    this.atualizarDtValidadeBalanco2(true);
    this.validarAno = true; 
  }, 1000); 
  // NOVO BLOCO: espelhar arquivos do modelo principal no modelo da tela
  if (
      this.model &&
      this.model.balancoFinanceiro &&
      this.modelQualificacao &&
      this.modelQualificacao.balancoFinanceiro
    ) {
      const bfModel = this.model.balancoFinanceiro;
      const bfTela  = this.modelQualificacao.balancoFinanceiro;

      // Balanço 1
      if (bfModel.arquivoUpload && !bfTela.arquivoUpload) {
        this.$set(bfTela, 'arquivoUpload', bfModel.arquivoUpload);
      }

      // Balanço 2
      if (bfModel.arquivoUpload02 && !bfTela.arquivoUpload02) {
        this.$set(bfTela, 'arquivoUpload02', bfModel.arquivoUpload02);
      }
    }
 },
 created() /*Metodo de start do componente*/ {
  this.gerarAnos();
   this.gerarAnos2();

   this.loadTela();
   if (this.OldModel && this.OldModel.balancoFinanceiro) {
     this.OldModel.balancoFinanceiro.mediaFinanceira = this.calcOldMediaFinanceira();
   }
   this.$store.commit("setCalcLimpa", {
     setCalcLimpa: 2
   });

   // Ticket #188855 - Ajustes Data de Vencimento Balanços 01 e 02
   let dataOriginal = this.model.balancoFinanceiro.dtBalanco;
   let ano = dataOriginal.split("-")[0]; 
   this.anoValidadeBalanco = ano;
   // Fim Ticket #188855 - Ajustes Data de Vencimento Balanços 01 e 02
if(Number(this.model.balancoFinanceiro.anoBalanco2) > 2000){
   this.modelQualificacao.balancoFinanceiro.anoBalanco2 = Number(this.model.balancoFinanceiro.anoBalanco2);
   
}

   this.modelQualificacao.balancoFinanceiro.anoBalanco = Number(this.model.balancoFinanceiro.anoBalanco);   
 
 },
 data() {//Declaracao de variaveis
   return {
     dialog: false,
     refreshAba: 0,
     ativoShow: true,
     passivoShow: true,
     receitaShow: true,
     ativoNaoCirculante: 0,
     ativoNaoCirculante02: 0,
     ativoTotal: 0,
     ativoTotal02: 0,
     passivoNaoCirculante: 0,
     passivoNaoCirculante02: 0,
     passivoTotal: 0,
     passivoTotal02: 0,
     solvenciaGeral: 0,
     solvenciaGeral02: 0,
     liquidezCorrente: 0,
     liquidezCorrente02: 0,
     liquidezGeral: 0,
     liquidezGeral02: 0,
     produtividade: 0,
     produtividade02: 0,
     endividamento: 0,
     endividamento02: 0,
     capitalizacao: 0,
     capitalizacao02: 0,
     imobilizacaoCapitalProprio: 0,
     imobilizacaoCapitalProprio02: 0,
     mediaFinanceira: 0,
     mediaFinanceira02: 0,
     obrigaBalanco2: '',
     TipoDelete: '',
     anoValidadeBalanco: '',// Ticket #188855    
     anos: [],
     anos2: [],
     componentKey: 0, 
     validarAno: false
   };
 }, 
 watch: {
  // ✅ WATCHER PRINCIPAL - Responsável pelos CÁLCULOS
  "modelQualificacao.balancoFinanceiro": {
    handler() {
      this.calcAtivos();
      this.calcPassivos();
      this.calcSolvencia();
      this.calcLiqCorrente();
      this.calcLiqGeral();
      this.calcProdutividade();
      this.calcEndividamento();
      this.calcICP();
      this.calcCapitalizacao();
      this.calcMediaFinanceira();
    },
    deep: true
  },
  
  // ✅ SINCRONIZAÇÃO CONCORDATA - Campo a campo
  "modelQualificacao.concordataFalencia.numDocumento": {
    handler(novoValor) {
      if (this.model.concordataFalencia) {
        this.$set(this.model.concordataFalencia, 'numDocumento', novoValor);
      }
    }
  },
  "modelQualificacao.concordataFalencia.dtEmissao": {
    handler(novoValor) {
      if (this.model.concordataFalencia) {
        this.$set(this.model.concordataFalencia, 'dtEmissao', novoValor);
      }
    }
  },
  "modelQualificacao.concordataFalencia.dtVencimento": {
    handler(novoValor) {
      if (this.model.concordataFalencia) {
        this.$set(this.model.concordataFalencia, 'dtVencimento', novoValor);
      }
    }
  },
  "modelQualificacao.concordataFalencia.situacaoDoc": {
    handler(novoValor) {
      if (this.model.concordataFalencia) {
        this.$set(this.model.concordataFalencia, 'situacaoDoc', novoValor);
      }
    }
  },
  "modelQualificacao.concordataFalencia.codControle": {
    handler(novoValor) {
      if (this.model.concordataFalencia) {
        this.$set(this.model.concordataFalencia, 'codControle', novoValor);
      }
    }
  },
  
  // ✅ SINCRONIZAÇÃO BALANÇO 01 - TODOS os campos
  "modelQualificacao.balancoFinanceiro.numLivroDiario": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'numLivroDiario', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.dtBalanco": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'dtBalanco', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.dtValidadeBalanco": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'dtValidadeBalanco', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.anoBalanco": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'anoBalanco', novoValor);
      }
    }
  },
  // CAMPOS DE VALOR - BALANÇO 01
  "modelQualificacao.balancoFinanceiro.ativoCirculante": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'ativoCirculante', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.realizavelLP": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'realizavelLP', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.investimento": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'investimento', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.imobilizado": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'imobilizado', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.intangivel": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'intangivel', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.passivoCirculante": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'passivoCirculante', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.exigivelLP": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'exigivelLP', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.resultExerciciosFut": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'resultExerciciosFut', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.patrimonioLiquido": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'patrimonioLiquido', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.capitalSocial": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'capitalSocial', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.receitaOpeLiquido": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'receitaOpeLiquido', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.receitaOpeBruto": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'receitaOpeBruto', novoValor);
      }
    }
  },
  
  // ✅ SINCRONIZAÇÃO BALANÇO 02 - TODOS os campos (COM 02)
  "modelQualificacao.balancoFinanceiro.numLivroDiario02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'numLivroDiario02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.dtBalanco02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'dtBalanco02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.dtValidadeBalanco02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'dtValidadeBalanco02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.anoBalanco2": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'anoBalanco2', novoValor);
      }
    }
  },
  // CAMPOS DE VALOR - BALANÇO 02
  "modelQualificacao.balancoFinanceiro.ativoCirculante02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'ativoCirculante02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.realizavelLP02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'realizavelLP02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.investimento02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'investimento02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.imobilizado02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'imobilizado02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.intangivel02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'intangivel02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.passivoCirculante02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'passivoCirculante02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.exigivelLP02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'exigivelLP02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.resultExerciciosFut02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'resultExerciciosFut02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.patrimonioLiquido02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'patrimonioLiquido02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.capitalSocial02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'capitalSocial02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.receitaOpeLiquido02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'receitaOpeLiquido02', novoValor);
      }
    }
  },
  "modelQualificacao.balancoFinanceiro.receitaOpeBruto02": {
    handler(novoValor) {
      if (this.model.balancoFinanceiro) {
        this.$set(this.model.balancoFinanceiro, 'receitaOpeBruto02', novoValor);
      }
    }
  }
},
 methods: {//Declaracao de todos os metodos
      validaAnoValido(ano, balanco) {
        let getAno = Number(ano);
        let anosValidos = balanco === 2 ? this.anos2 : this.anos;

        if (!this.validarAno) {
            return true;  // Não valida até que o valor seja setado
        }
        if (balanco === 2 && this.modelQualificacao.concordataFalencia.arquivoUpload02 == null){
                  
          return true;
        }
        if (anosValidos.includes(getAno)) {
            return true;
        } else {
            if (balanco === 1) {
                this.modelQualificacao.balancoFinanceiro.anoBalanco = null;
            } else if (balanco === 2) {
                this.modelQualificacao.balancoFinanceiro.anoBalanco2 = null;
            }
            return false;
        }
    },
   iconDelete(item, tipo) {
     this.dialog = true;
     this.TipoDelete = tipo;
   },
   gerarAnos() {
     const anoAtual = new Date().getFullYear();
     this.anos = [anoAtual, anoAtual - 1, anoAtual - 2];
   },
   gerarAnos2() {
     const anoAtual = new Date().getFullYear();
     this.anos2 = [ anoAtual - 2, anoAtual - 3];
   },
   cancelarDialog() {
     this.dialog = false;
   },

   loadTela() {
     //metodo para carregar a tela
     this.enums.situacaoDoc.unshift({
       chave: "-Selecione-",
       valor: null,
       descricao: "-Selecione-"
     });
     this.model.concordataFalencia = this.model.concordataFalencia ? this.model.concordataFalencia : {};
     this.model.balancoFinanceiro = this.model.balancoFinanceiro ? this.model.balancoFinanceiro : {};

     this.modelQualificacao.concordataFalencia = Object.assign(
       {},
       this.modelQualificacao.concordataFalencia,
       this.model.concordataFalencia
     );

     this.modelQualificacao.balancoFinanceiro = Object.assign(
       {},
       this.modelQualificacao.balancoFinanceiro,
       this.model.balancoFinanceiro
     );

     this.modelQualificacao.concordataFalencia.novoUpload = this.modelQualificacao.concordataFalencia.arquivoUpload ? false : true;
     this.modelQualificacao.balancoFinanceiro.novoUpload = this.modelQualificacao.balancoFinanceiro.arquivoUpload ? false : true;
     this.modelQualificacao.balancoFinanceiro.novoUpload02 = this.modelQualificacao.balancoFinanceiro.arquivoUpload02 ? false : true;

     this.modelQualificacao.concordataFalencia.limparArquivoUpload = false;
     this.modelQualificacao.balancoFinanceiro.limparArquivoUpload = false;
     this.modelQualificacao.balancoFinanceiro.limparArquivoUpload02 = false;

     this.modelQualificacao.balancoFinanceiro.identificador_balanco = 1;
     this.model.balancoFinanceiro.identificador_balanco = 1;

     this.obrigaBalanco2 = this.obrigarBalanco2();
   },
   obrigarBalanco2() {
    let regularidadeFiscTrabAberturaEmp = this.model.regularidadeFiscTrab.find(
        x => x.tipDocumento === 1
    );
    const balanco = this.modelQualificacao.balancoFinanceiro;

    const camposObrigatorios02 = Object.keys(balanco).filter(key =>
      key.endsWith('02') &&
      key !== 'dtValidadeBalanco02' &&  key !== 'codDocumentoSIMPAS02' &&  key !== 'limparArquivoUpload02'
      &&  key !== 'novoUpload02'  &&  key !== 'numDocumentoSEI02'
    );

    const algumCampoPreenchidoEValido = camposObrigatorios02.some(key => {
      const valor = balanco[key];

      // Se for campo de data, verificar validade com moment
      if (key.toLowerCase().startsWith('dt') && typeof valor === 'string') {
        const data = moment(valor, moment.ISO_8601, true);
        return data.isValid();
      }

      // Ignorar valores considerados "não preenchidos"
      if (
        valor === null ||
        valor === undefined ||
        valor === '' ||
        valor === 0 ||
        valor === '0' ||
        valor === '0.00'
      ) {
        return false;
      }

      return true;
    });
    if (algumCampoPreenchidoEValido && !balanco.arquivoUpload02) {
      return 'obrigabalanco2';
    }

    if (!regularidadeFiscTrabAberturaEmp || !regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa) {
        return 'semBalanco2'; // Se não houver data de abertura, não obriga
    }

    // Ajustando a data de abertura se estiver entre 15/12 e 31/12
    let dataAbertura = moment(regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa);
    if (dataAbertura.isBetween(`${dataAbertura.year()}-12-15`, `${dataAbertura.year()}-12-31`, null, '[]')) {
        dataAbertura.add(1, 'year').startOf('year');
    }

    let dataDoisAnos = dataAbertura.clone().add(2, 'years');
    let dataAtual = moment(); // Data do dia atual

    // Caso a empresa tenha menos de 2 anos, nunca obriga
    if (dataAtual.isBefore(dataDoisAnos)) {
        return 'Nobrigabalanco2';
    }

    // Calcula o último dia útil de junho do ano atual
    let ultimoDiaUtilJunho = moment(`${dataAtual.year()}-06-30`);
    if (ultimoDiaUtilJunho.day() === 6) {
        ultimoDiaUtilJunho.subtract(1, 'days'); // Se for sábado, volta para sexta
    } else if (ultimoDiaUtilJunho.day() === 0) {
        ultimoDiaUtilJunho.subtract(2, 'days'); // Se for domingo, volta para sexta
    }

    // Se completou 2 anos no primeiro semestre e ainda não passou do último dia útil de junho
    if (dataDoisAnos.year() === dataAtual.year() &&
        dataDoisAnos.month() < 6 &&
        dataAtual.isBefore(ultimoDiaUtilJunho)
    ) {
        return 'Nobrigabalanco2';
    }

    return 'obrigabalanco2'; // Se já passou do prazo, exige normalmente
},
   testeAstericoEstrangeiro() {
     //testar se o documento é obrigatorio para estrangeiro
     if (!(this.model.tipoCertificado === 2 && (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F"))
       && this.model.flagEstrangeiro === '0')
       return " *";
     else return "";
   },
   validaIfObrigatorio(v) {
     //testar se o documento é obrigatorio
     /* tipoCertificado é tipo number, tipFornecedor é tipo string */
     if (!(this.model.tipoCertificado === 2 && (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F"))
       && this.model.flagEstrangeiro === '0') {
       return !!v;
     } else {
       return true;
     }
   },
   validaAnoAnterior(data, quantosAnos) {
     if (this.obrigarBalanco2() != 'obrigabalanco2' 
     && (this.modelQualificacao.balancoFinanceiro.file02 === undefined 
     || this.modelQualificacao.balancoFinanceiro.file02 === null) && quantosAnos == 2) {
       return true;
     }

     if(this.$verificaPerfilHabilitador() && quantosAnos == 1 && this.model.balancoFinanceiro.arquivoUploadSituacao === 1){
       return true;
     }
        if(this.$verificaPerfilHabilitador() && quantosAnos == 2 && this.model.balancoFinanceiro.arquivoUploadSituacao02 === 1){
       return true;
     }   
  
     let regularidadeFiscTrabAberturaEmp = this.model.regularidadeFiscTrab.find(x => x.tipDocumento === 1);
     const a = moment(regularidadeFiscTrabAberturaEmp.dtAberturaEmpresa).year();
     const b = moment(this.model.dataSolicitacao);

     if (data === '' && (this.modelQualificacao.balancoFinanceiro.file02 === null && this.obrigarBalanco2() != 'obrigabalanco2')) {
       return true;
     } else {
      const anoAtual = new Date().getFullYear();
          const partesData = data.split('/');
          const dataConvertida = new Date(`${partesData[2]}-${partesData[1]}-${partesData[0]}`);
          const anoData = dataConvertida.getFullYear();
          const mesAtual = new Date().getMonth() + 1; // Janeiro = 0
          const primeiroSemestre = mesAtual <= 6;

          // Verificar se é Balanço 01
          if (quantosAnos === 1) {
            if(a === anoData){
            return true;
          }
            if (primeiroSemestre) {
              // Primeiro semestre: ano pode ser do ano anterior ou dois anos antes
              return anoData === anoAtual - 1 || anoData === anoAtual - 2;
            } else {
              // Segundo semestre: ano pode ser apenas do ano anterior
              return anoData === anoAtual - 1;
            }
          }

          // Verificar se é Balanço 02
          if (quantosAnos === 2) {
            if (primeiroSemestre) {
              // Primeiro semestre: ano pode ser dois ou três anos antes
              return anoData === anoAtual - 2 || anoData === anoAtual - 3;
            } else {
              // Segundo semestre: ano pode ser apenas dois anos antes
              return anoData === anoAtual - 2;
            }
          }

          return false; // Caso nenhum dos cenários seja válido
            }
   },
   validaIfObrigatorioBalanco2(v, valor) {
    
    this.obrigaBalanco2 = this.obrigarBalanco2();
    
     if (this.obrigaBalanco2 === 'Nobrigabalanco2') {
       return true;
     }
     else if (v) {
       return v.length === 10;
     } else {
       return false;
     }

   },
   validaIfObrigatorioSit(v, valor) {
     //validar se é obrigatorio o documento

     //valida campo situacaoDoc 
     if (valor === 'situacaoDoc' && v == 0) {
       return true;
     } else if (
       !(
         this.model.tipoCertificado === 2 && // tipoCertificado é do tipo number
         (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F")
       ) &&
       this.model.flagEstrangeiro === '0'
     ) {
       return !!v;
     } else {
       return true;
     }
   },
   validaIfObrigatorioDtBalanco(v) {
     // verificar se a data do balanco é obrigatorio
     /* tipoCertificado é tipo number, tipFornecedor é tipo string, arquivoUploadSituacao é tipo number */
     if (!(this.model.tipoCertificado === 2 && (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F"))
       && this.model.flagEstrangeiro === '0' && this.model.balancoFinanceiro.arquivoUploadSituacao === 2) {
       return !!v;
     } else {
       return true;
     }
   },
   validaIfObrigatorioDtValidadeBalanco2(v) {
     // verificar se a data do balanco é obrigatorio
     /* tipoCertificado é tipo number, tipFornecedor é tipo string, arquivoUploadSituacao é tipo number */
     if (this.model.tipoCertificado === 1 && this.model.balancoFinanceiro.arquivoUpload02 == null) {
       return true;
     } else {     
       return !!v;
     }
   },
   testeAstericoDtBalanco() {
     // verificar se a data do balanço é obrigatoria
     /* tipoCertificado é tipo number, tipFornecedor é tipo string, arquivoUploadSituacao é tipo number */
     if (!(this.model.tipoCertificado === 2 && (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F"))
       && this.model.flagEstrangeiro === '0' && this.model.balancoFinanceiro.arquivoUploadSituacao === 2)
       return " *";
     else return "";
   },
   validaDataInvalida(v) {
     //verificar se a data é invalida

     if (
       !(this.model.tipoCertificado === 2 && (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F"))
       && this.model.flagEstrangeiro === '0') {
       return v.length === 10;
     } else {
       if (v) {
         return v.length === 10;
       } else {
         return true;
       }
     }
   },
   validaDataInvalidaBalanco2(v) {
     //validar se data é invalida
     if (this.obrigarBalanco2 === 'obrigabalanco2') {
       if (!(this.model.tipoCertificado === 2 && (this.model.tipFornecedor === "J" || this.model.tipFornecedor === "F"))
         && this.model.flagEstrangeiro === 0) {
         return v.length === 10;
       } else {
         if (v) {
           return v.length === 10;
         } else {
           return true;
         }
       }
     } else {
       return true;
     }
   },
   baixarArquivo(arquivo) {
     //metodo para baixar o arquivo
     const numCgcFornecedor = this.$verificaPerfilHabilitador()
       ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "")
       : null;
     fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
   },
   limparAnexo(tipo) {
     //metodo para limpar os anexos
     if (tipo === "concordata") {
       this.modelQualificacao.concordataFalencia.novoUpload = true;
       this.modelQualificacao.concordataFalencia.file = null;
       this.model.concordataFalencia.arquivoUpload = null;
       this.modelQualificacao.concordataFalencia.limparArquivoUpload = true;
     }

     if (tipo === "balanco") {
       this.modelQualificacao.balancoFinanceiro.novoUpload = true;
       this.modelQualificacao.balancoFinanceiro.file = null;
       this.model.balancoFinanceiro.arquivoUpload = null;
       this.modelQualificacao.balancoFinanceiro.limparArquivoUpload = true;

     }


     if (tipo === "balanco2") {

       this.modelQualificacao.balancoFinanceiro.novoUpload02 = true;
       this.modelQualificacao.balancoFinanceiro.file02 = null;
       this.model.balancoFinanceiro.arquivoUpload02 = null;
       this.modelQualificacao.balancoFinanceiro.limparArquivoUpload02 = true;
     }
     this.cancelarDialog();
   },
   openBox(item) {
     //metodo para expandir detalhes do documento
     const flag = this.isShow[item.chave + "" + item.valor];
     this.$set(this.isShow, item.chave + "" + item.valor, !flag);
   },

   atualizarDtValidadeBalanco(Inicial) {
   
   
        this.atualizarBalancoPrincipal(Inicial);
      
        if(this.model.balancoFinanceiro.anoBalanco2 != null || Inicial == false) {
            this.atualizarBalancoSecundario(Inicial);
            this.componentKey += 1;
        }
        
    },

    atualizarDtValidadeBalanco2(Inicial) {

        if(Inicial == false){
            this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao02 = null;
            this.model.balancoFinanceiro.arquivoUploadSituacao02 = null;
        }

        if(this.model.balancoFinanceiro.anoBalanco2 != null || Inicial == false) {
           
            this.atualizarBalancoSecundario(Inicial);
            this.atualizarBalancoPrincipal(false);
            this.componentKey += 1;
        }
        else{
          this.modelQualificacao.balancoFinanceiro.anoBalanco2 = null;
        }
    },

    parseDateSeguro(value) {
      if (!value) return null;

      // ISO / yyyy-mm-dd / yyyy-mm-ddTHH:mm:ss
      if (typeof value === 'string' && value.includes('-')) {
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
      }

      // dd/mm/yyyy
      if (typeof value === 'string' && value.includes('/')) {
        const [dd, mm, yyyy] = value.split('/');
        const d = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
        return isNaN(d.getTime()) ? null : d;
      }

      // fallback
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    },

    atualizarBalancoPrincipal(Inicial) {
      const dtBalancoQualificado = this.modelQualificacao.balancoFinanceiro.dtBalanco;
      const dtBalancoPrincipal = this.model.balancoFinanceiro.dtBalanco;

      if (dtBalancoPrincipal != null || Inicial == false) {
        if (!dtBalancoQualificado) {
          this.modelQualificacao.balancoFinanceiro.dtBalanco = dtBalancoPrincipal;
        }

        const dataBalanco = this.parseDateSeguro(
          this.modelQualificacao.balancoFinanceiro.dtBalanco || dtBalancoPrincipal
        );
        if (!dataBalanco) return;

        if (isNaN(dataBalanco.getTime())) {
          console.warn('Data de balanço inválida.');
          return;
        }

        // -----------------------------
        // 1) Detecta "Balanço de Abertura"
        // dt-base diferente de 31/12
        // -----------------------------
        const dia = dataBalanco.getDate();
        const mes = dataBalanco.getMonth() + 1; // Jan=1 ... Dez=12
        const isAbertura = !(dia === 31 && mes === 12);

        // Ano vigente (do sistema)
        const anoVigente = new Date().getFullYear();

        let anoParaPreencher;

        if (isAbertura) {
          // EXCEÇÃO (apenas B01): validade = junho do ano seguinte ao ano de referência do balanço
          const anoReferencia = dataBalanco.getFullYear();
          anoParaPreencher = anoReferencia + 1;
        } else {
          // REGRA PADRÃO (186305) para B01 (balanço normal 31/12)
          // Usamos o ano selecionado no combo (anoBalanco) para decidir a validade:
          // - se anoBalanco == ano vigente: validade = 30/06 do ano vigente+1
          // - se anoBalanco == ano vigente-1: validade = 30/06 do ano vigente+1
          // - se anoBalanco == ano vigente-2 (mais antigo): validade = 30/06 do ano vigente
          const anoEscolhido = Number(this.modelQualificacao.balancoFinanceiro.anoBalanco);

          if (anoEscolhido === anoVigente || anoEscolhido === (anoVigente - 1)) {
            anoParaPreencher = anoVigente + 1;
          } else if (anoEscolhido === (anoVigente - 2)) {
            anoParaPreencher = anoVigente;
          } else {
            // fallback seguro: se por algum motivo o ano não estiver no esperado,
            // mantém o comportamento mais conservador (ano vigente+1)
            anoParaPreencher = anoVigente + 1;
          }
        }

        // Calcula último dia útil de junho do anoParaPreencher
        const ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoParaPreencher);
        const dataISO = new Date(
          `${anoParaPreencher}-06-${this.zeroPad(ultimoDiaUtilDeJunho)}T00:00:00`
        ).toISOString();

        // Seta em tela + model
        this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = dataISO;
        this.model.balancoFinanceiro.dtValidadeBalanco = dataISO;

        // Atualiza UI do datePicker (se necessário)
        if (this.$refs.dtValidadeBalanco) {
          this.$refs.dtValidadeBalanco.date = `${anoParaPreencher}-06-${this.zeroPad(ultimoDiaUtilDeJunho)}`;

          this.$nextTick(() => {
            const inputElement = this.$refs.dtValidadeBalanco.$el.querySelector('input');
            if (inputElement) {
              inputElement.value = `${this.zeroPad(ultimoDiaUtilDeJunho)}/06/${anoParaPreencher}`;
              inputElement.dispatchEvent(new Event('input'));
            }
          });
        }

      } else {
        this.modelQualificacao.balancoFinanceiro.anoBalanco = null;
      }
    },


atualizarBalancoSecundario(Inicial) {
  // Garante que dtBalanco02 esteja definido (usa modelQualificacao como prioritário)
  const dataBalanco2 = this.modelQualificacao.balancoFinanceiro.dtBalanco02 
    ? new Date(this.modelQualificacao.balancoFinanceiro.dtBalanco02)
    : new Date(this.model.balancoFinanceiro.dtBalanco02);

  // Valida a data e o ano extraído
  if (!isNaN(dataBalanco2.getTime())) {
    const anoEscolhido = dataBalanco2.getFullYear();
    const anoVigente = new Date().getFullYear();
    let anoParaPreencher;

    if (anoEscolhido === anoVigente - 2 || anoEscolhido === anoVigente - 1 || anoEscolhido === anoVigente) {
      anoParaPreencher = anoVigente + 1;
    } else {
      anoParaPreencher = anoVigente;
    }

    const ultimoDiaUtilDeJunho = this.getUltimoDiaUtilDeJunho(anoParaPreencher);

    const dataISO = new Date(anoParaPreencher, 5, ultimoDiaUtilDeJunho, 0, 0, 0).toISOString();

    if(this.modelQualificacao.balancoFinanceiro.arquivoUpload02 != null){
    this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco02 = dataISO;    
    this.model.balancoFinanceiro.dtValidadeBalanco02 = dataISO;
      this.$refs.dtValidadeBalanco02.date = `${anoParaPreencher}-${this.zeroPad(6)}-${this.zeroPad(ultimoDiaUtilDeJunho)}`;

    this.$nextTick(() => {
      const inputElement = this.$refs.dtValidadeBalanco02.$el.querySelector('input');
      if (inputElement) {
        inputElement.value = `${this.zeroPad(ultimoDiaUtilDeJunho)}/06/${anoParaPreencher}`;
        inputElement.dispatchEvent(new Event('input'));
      }
    });
    }
  }
},

getUltimoDiaUtilDeJunho(ano) {
    let data = new Date(ano, 5, 30); // Mês 5 = junho (mês começa em 0)
    
    // Enquanto o dia não for útil (segunda a sexta), vai voltando um dia
    while (data.getDay() === 0 || data.getDay() === 6) {
      data.setDate(data.getDate() - 1);
    }
    
    return data.getDate(); // Retorna o dia do mês (1 a 31)
},
zeroPad(num) {
    return num.toString().padStart(2, '0');
},



   MudarBalanco1Para2(){

     this.atualizarDtValidadeBalanco(false);
     this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao = null;
     this.model.balancoFinanceiro.arquivoUploadSituacao = null;

     if (this.model.balancoFinanceiro.arquivoUpload && this.model.balancoFinanceiro.arquivoUpload.includes('https')
     && this.model.balancoFinanceiro.arquivoUpload != this.model.balancoFinanceiro.arquivoUpload02) {
 
     this.$refs.dtBalanco02.date = this.$refs.dtBalanco.date;
     this.modelQualificacao.balancoFinanceiro.dtBalanco02 = this.modelQualificacao.balancoFinanceiro.dtBalanco;

       // Limpar o valor de dtBalanco
       this.modelQualificacao.balancoFinanceiro.dtBalanco = '';

       // Verificar se o componente de data tem um método de reset
       this.$nextTick(() => {  
           const inputElement = this.$refs.dtBalanco.$el.querySelector('input');
           if (inputElement) {
             inputElement.value = '';
             inputElement.dispatchEvent(new Event('input'));
           }  
       });

   
   this.modelQualificacao.balancoFinanceiro.numLivroDiario02 = this.modelQualificacao.balancoFinanceiro.numLivroDiario;
   this.modelQualificacao.balancoFinanceiro.numLivroDiario = null

   this.$refs.dtValidadeBalanco02.date = this.$refs.dtValidadeBalanco.date;

   this.$nextTick(() => {  
           const inputElement = this.$refs.dtValidadeBalanco.$el.querySelector('input');
           if (inputElement) {
             inputElement.value = '';
             inputElement.dispatchEvent(new Event('input'));
           }  
       });

       

       this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao = null;
       this.modelQualificacao.balancoFinanceiro.novoUpload = true;
       this.modelQualificacao.balancoFinanceiro.file = null;
       this.model.balancoFinanceiro.arquivoUpload = null;
       this.modelQualificacao.balancoFinanceiro.limparArquivoUpload = true;

       this.model.balancoFinanceiro.dtBalanco02 = this.model.balancoFinanceiro.dtBalanco;

      this.modelQualificacao.balancoFinanceiro.ativoCirculante02 = this.modelQualificacao.balancoFinanceiro.ativoCirculante;
 
   this.modelQualificacao.balancoFinanceiro.ativoNaoCirculante02 = this.modelQualificacao.balancoFinanceiro.ativoNaoCirculante;
   this.modelQualificacao.balancoFinanceiro.realizavelLP02 = this.modelQualificacao.balancoFinanceiro.realizavelLP;
   this.modelQualificacao.balancoFinanceiro.investimento02 = this.modelQualificacao.balancoFinanceiro.investimento;
   this.modelQualificacao.balancoFinanceiro.imobilizado02 = this.modelQualificacao.balancoFinanceiro.imobilizado;
   this.modelQualificacao.balancoFinanceiro.intangivel02 = this.modelQualificacao.balancoFinanceiro.intangivel;
   this.modelQualificacao.balancoFinanceiro.ativoTotal02 = this.modelQualificacao.balancoFinanceiro.ativoTotal;
   this.modelQualificacao.balancoFinanceiro.passivoCirculante02 = this.modelQualificacao.balancoFinanceiro.passivoCirculante;
   this.modelQualificacao.balancoFinanceiro.passivoNaoCirculante02 = this.modelQualificacao.balancoFinanceiro.passivoNaoCirculante;
   this.modelQualificacao.balancoFinanceiro.exigivelLP02 = this.modelQualificacao.balancoFinanceiro.exigivelLP;
   this.modelQualificacao.balancoFinanceiro.resultExerciciosFut02 = this.modelQualificacao.balancoFinanceiro.resultExerciciosFut;
   this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02 = this.modelQualificacao.balancoFinanceiro.patrimonioLiquido;
   this.modelQualificacao.balancoFinanceiro.passivoTotal02 = this.modelQualificacao.balancoFinanceiro.passivoTotal;
   this.modelQualificacao.balancoFinanceiro.capitalSocial02 = this.modelQualificacao.balancoFinanceiro.capitalSocial;
   this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02 = this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido;
   this.modelQualificacao.balancoFinanceiro.receitaOpeBruto02 = this.modelQualificacao.balancoFinanceiro.receitaOpeBruto;
   this.modelQualificacao.balancoFinanceiro.anoBalanco2 = this.modelQualificacao.balancoFinanceiro.anoBalanco;
   
   this.$refs.anoBalanco2 = this.$refs.anoBalanco2 +1;

this.$nextTick(() => {  
       const inputElementA = this.$refs.anoBalanco2.$el.querySelector('input');
       if (inputElementA) {
         inputElementA.value = this.$refs.anoBalanco2 +1;
         inputElementA.dispatchEvent(new Event('input'));
       }  
   });

   this.mediaFinanceira02 = this.mediaFinanceira;
   this.liquidezCorrente02 = this.liquidezCorrente;
   this.liquidezGeral02 = this.liquidezGeral;
   this.solvenciaGeral02 = this.solvenciaGeral;
   this.produtividade02 = this.produtividade;
   this.endividamento02 = this.endividamento;
   this.imobilizacaoCapitalProprio02 = this.imobilizacaoCapitalProprio;
   this.capitalizacao02 = this.capitalizacao;

   let cal1 =
       Number(this.ativoTotal02) - Number(this.modelQualificacao.balancoFinanceiro.investimento02);
   this.produtividade02 = cal1 &&
       Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02) ? Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02) / cal1 : 0;

       
   // Limpar valores
   this.model.balancoFinanceiro.arquivoUpload = null;
   this.modelQualificacao.balancoFinanceiro.dtValidadeBalanco = null;
   this.model.balancoFinanceiro.dtValidadeBalanco = null;
   this.modelQualificacao.balancoFinanceiro.ativoCirculante = null;
   this.modelQualificacao.balancoFinanceiro.ativoNaoCirculante = null;
   this.modelQualificacao.balancoFinanceiro.realizavelLP = null;
   this.modelQualificacao.balancoFinanceiro.investimento = null;
   this.modelQualificacao.balancoFinanceiro.imobilizado = null;
   this.modelQualificacao.balancoFinanceiro.intangivel = null;
   this.modelQualificacao.balancoFinanceiro.ativoTotal = null;
   this.modelQualificacao.balancoFinanceiro.passivoCirculante = null;
   this.modelQualificacao.balancoFinanceiro.passivoNaoCirculante = null;
   this.modelQualificacao.balancoFinanceiro.exigivelLP = null;
   this.modelQualificacao.balancoFinanceiro.resultExerciciosFut = null;
   this.modelQualificacao.balancoFinanceiro.patrimonioLiquido = null;
   this.modelQualificacao.balancoFinanceiro.passivoTotal = null;
   this.modelQualificacao.balancoFinanceiro.capitalSocial = null;
   this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido = null;
   this.modelQualificacao.balancoFinanceiro.receitaOpeBruto = null;
   this.mediaFinanceira = null;
   this.liquidezCorrente = null;
   this.liquidezGeral = null;
   this.solvenciaGeral = null;
   this.produtividade = null;
   this.endividamento = null;
   this.imobilizacaoCapitalProprio = null;
   this.capitalizacao = null;
   

   

   this.calcMediaFinanceira();

   this.componentKey += 1;
     }
   },
   calcAtivos() {
     //metodo para calular o total de ativo
     let _ativoNaoCirculante =
       Number(this.modelQualificacao.balancoFinanceiro.realizavelLP) +
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado) +
       Number(this.modelQualificacao.balancoFinanceiro.investimento) +
       Number(this.modelQualificacao.balancoFinanceiro.intangivel);
     this.ativoNaoCirculante = _ativoNaoCirculante ? _ativoNaoCirculante : 0;

     let _ativoTotal =
       Number(this.ativoNaoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante);
     this.ativoTotal = _ativoTotal ? _ativoTotal : 0;
     this.totaisContas.ativoTotal = this.ativoTotal.toFixed(2);

     //metodo para calular o total de ativo BALANCO02
     let _ativoNaoCirculante02 =
       Number(this.modelQualificacao.balancoFinanceiro.realizavelLP02) +
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado02) +
       Number(this.modelQualificacao.balancoFinanceiro.investimento02) +
       Number(this.modelQualificacao.balancoFinanceiro.intangivel02);
     this.ativoNaoCirculante02 = _ativoNaoCirculante02 ? _ativoNaoCirculante02 : 0;

     let _ativoTotal02 =
       Number(this.ativoNaoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02);
     this.ativoTotal02 = _ativoTotal02 ? _ativoTotal02 : 0;
     this.totaisContas.ativoTotal02 = this.ativoTotal02.toFixed(2);
   },
   calcPassivos() {
     //metodo para calcular o total de passivo
     let _passivoNaoCirculante =
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP) + Number(this.modelQualificacao.balancoFinanceiro.resultExerciciosFut);
     this.passivoNaoCirculante = _passivoNaoCirculante ? _passivoNaoCirculante : 0;

     let _passivoTotal =
       Number(this.passivoNaoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) +
       Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido);

     this.passivoTotal = _passivoTotal ? _passivoTotal : 0;
     this.totaisContas.passivoTotal = this.passivoTotal.toFixed(2);

     //metodo para calcular o total de passivo BALANÇO02

     let _passivoNaoCirculante02 =
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02) + Number(this.modelQualificacao.balancoFinanceiro.resultExerciciosFut02);
     this.passivoNaoCirculante02 = _passivoNaoCirculante02 ? _passivoNaoCirculante02 : 0;

     let _passivoTotal02 =
       Number(this.passivoNaoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) +
       Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02);

     this.passivoTotal02 = _passivoTotal02 ? _passivoTotal02 : 0;
     this.totaisContas.passivoTotal02 = this.passivoTotal02.toFixed(2);

   },
   calcSolvencia() {
     //calcular o valor de solvencia
     let cal1 =
       Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante) + Number(this.ativoNaoCirculante);
     let cal2 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP);
     let resultado = cal1 && cal2 ? cal1 / cal2 : 0;
     this.solvenciaGeral = resultado ? resultado : 0;

     //calcular o valor de solvencia BALANÇO02
     let calc1 =
       Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02) + Number(this.ativoNaoCirculante02);
     let calc2 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02);
     let resultado2 = calc1 && calc2 ? calc1 / calc2 : 0;
     this.solvenciaGeral02 = resultado2 ? resultado2 : 0;

   },
   calcLiqCorrente() {
     //calcular o valor liquido corrente
     this.liquidezCorrente =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante)
         ? Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante) / Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante)
         : 0;
     //calcular o valor liquido corrente BALANÇO02
     this.liquidezCorrente02 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02)
         ? Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02) / Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02)
         : 0;
   },
   calcLiqGeral() {
     //calcular o valor liquido geral
     let calc1 = Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.realizavelLP);
     let calc2 = Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP);

     this.liquidezGeral = calc1 && calc2 ? calc1 / calc2 : 0;

     //calcular o valor liquido geral BALANÇO02
     let cal1 = Number(this.modelQualificacao.balancoFinanceiro.ativoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.realizavelLP02);
     let cal2 = Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) + Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02);

     this.liquidezGeral02 = cal1 && cal2 ? cal1 / cal2 : 0;
   },
   calcProdutividade() {
     //calcular valor de produtividade
     let calc1 =
       Number(this.ativoTotal) - Number(this.modelQualificacao.balancoFinanceiro.investimento);

     this.produtividade = calc1 &&
       Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido) ? Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido) / calc1 : 0;

     //calcular valor de produtividade BALANÇO02
     let cal1 =
       Number(this.ativoTotal02) - Number(this.modelQualificacao.balancoFinanceiro.investimento02);

     this.produtividade02 = cal1 &&
       Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02) ? Number(this.modelQualificacao.balancoFinanceiro.receitaOpeLiquido02) / cal1 : 0;

   },
   calcEndividamento() {
     //calcular valor de endividamento
     let calc1 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante) +
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP);
     this.endividamento =
       calc1 && Number(this.ativoTotal) ? calc1 / Number(this.ativoTotal) : 0;

     //calcular valor de endividamento BALANÇO02
     let cal1 =
       Number(this.modelQualificacao.balancoFinanceiro.passivoCirculante02) +
       Number(this.modelQualificacao.balancoFinanceiro.exigivelLP02);
     this.endividamento02 =
       cal1 && Number(this.ativoTotal02) ? cal1 / Number(this.ativoTotal02) : 0;
   },
   calcCapitalizacao() {
     //calcular valor de capitalização
     this.capitalizacao = Number(this.ativoTotal) ?
       (Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido) / Number(this.ativoTotal)) * 100
       : 0;

     //calcular valor de capitalização BALANÇO02
     this.capitalizacao02 = Number(this.ativoTotal02) ?
       (Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02) / Number(this.ativoTotal02)) * 100
       : 0;
   },
   calcICP() {
     //calcular valor de ICP
     this.imobilizacaoCapitalProprio =
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado) &&
         Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido) ?
         (Number(this.modelQualificacao.balancoFinanceiro.imobilizado) /
           Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido)) * 100
         : 0;

     //calcular valor de ICP BALANÇO02
     this.imobilizacaoCapitalProprio02 =
       Number(this.modelQualificacao.balancoFinanceiro.imobilizado02) &&
         Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02) ?
         (Number(this.modelQualificacao.balancoFinanceiro.imobilizado02) /
           Number(this.modelQualificacao.balancoFinanceiro.patrimonioLiquido02)) * 100
         : 0;
   },
   getIndPont(codPontInd, valor) {
     //resgatar indice de pontacao
     let valores = this.pontuacaoIndices.find(
       pontuacao =>
         pontuacao.codPontInd == codPontInd &&
         valor >= pontuacao.limInf &&
         valor <= pontuacao.limSup
     );
     return valores ? valores.indPont : 0;
   },
   calcMediaFinanceira() {
     //calcular media financeira
     let ntProd = this.getIndPont(1, this.produtividade);
     let ntLG = this.getIndPont(2, this.liquidezGeral);
     let ntLC = this.getIndPont(3, this.liquidezCorrente);
     let ntCap = this.getIndPont(4, this.capitalizacao);
     let ntICP = this.getIndPont(5, this.imobilizacaoCapitalProprio);

       
       
     this.mediaFinanceira = (ntProd + ntLG + ntLC + ntCap + ntICP) / 5;

     //calcular media financeira BALANÇO02

     let ntProd2 = this.getIndPont(1, this.produtividade02);
     let ntLG2 = this.getIndPont(2, this.liquidezGeral02);
     let ntLC2 = this.getIndPont(3, this.liquidezCorrente02);
     let ntCap2 = this.getIndPont(4, this.capitalizacao02);
     let ntICP2 = this.getIndPont(5, this.imobilizacaoCapitalProprio02);

     this.mediaFinanceira02 = (ntProd2 + ntLG2 + ntLC2 + ntCap2 + ntICP2) / 5;
   },
   calcOldMediaFinanceira() {
     //calcular media financeira do modelo antigo
     let ntProd = this.getIndPont(1, this.OldModel.balancoFinanceiro.produtividade);
     let ntLG = this.getIndPont(2, this.OldModel.balancoFinanceiro.liquidezGeral);
     let ntLC = this.getIndPont(3, this.OldModel.balancoFinanceiro.liquidezCorrente);
     let ntCap = this.getIndPont(4, this.OldModel.balancoFinanceiro.capitalizacao);
     let ntICP = this.getIndPont(5, this.OldModel.balancoFinanceiro.imobilizacaoCapitalProprio);

     return (ntProd + ntLG + ntLC + ntCap + ntICP) / 5;

   },
   calcOldMediaFinanceira2() {
     //calcular media financeira do modelo antigo
     let ntProd02 = this.getIndPont(1, this.OldModel.balancoFinanceiro.produtividade02);
     let ntLG02 = this.getIndPont(2, this.OldModel.balancoFinanceiro.liquidezGeral02);
     let ntLC02 = this.getIndPont(3, this.OldModel.balancoFinanceiro.liquidezCorrente02);
     let ntCap02 = this.getIndPont(4, this.OldModel.balancoFinanceiro.capitalizaca02);
     let ntICP02 = this.getIndPont(5, this.OldModel.balancoFinanceiro.imobilizacaoCapitalProprio02);

     return (ntProd02 + ntLG02 + ntLC02 + ntCap02 + ntICP02) / 5;

   },
   formatarNumero(valor, percent) {
     //formatar moeda ou percentual
     return (
       (!percent ? "R$ " : "") +
       valor.toLocaleString("pt-BR", {
         minimumFractionDigits: 2,
         maximumFractionDigits: 2
       }) + (percent ? "%" : "")
     );
   },
   validarCampo(situacao, tipo, motivo) {
     this.$store.commit("setCalcLimpa", {
       setCalcLimpa: 2
     });
     //metodo para aprovar ou rejeitar o documento
     if (tipo === "c") {
       this.validaConcordata(situacao, motivo);
     } else {
       this.validaBalanco(situacao, motivo, tipo);
     }
   },
   validaConcordata(situacao, motivo) {

     //metodo para validar concordata
     const model = Object.assign(
       {},
       this.modelQualificacao.concordataFalencia
     );
     model.numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "");
     model.arquivoUploadSituacao = situacao;
     model.idMotivoIndeferimentoArquivo = motivo;

     qualificacaoEconomicaService
       .aprovarRejeitarConcordataFalencia(model)
       .then(response => { /*resposta do servico*/
         this.model.concordataFalencia.arquivoUploadSituacao = response.data.arquivoUploadSituacao;
         this.model.concordataFalencia.idMotivoIndeferimentoArquivo = response.data.idMotivoIndeferimentoArquivo;
         this.model.concordataFalencia.dtRejeicao = response.data.dtRejeicao;

         this.modelQualificacao.concordataFalencia.arquivoUploadSituacao = response.data.arquivoUploadSituacao;
         this.modelQualificacao.concordataFalencia.idMotivoIndeferimentoArquivo = response.data.idMotivoIndeferimentoArquivo;
         this.modelQualificacao.concordataFalencia.dtRejeicao = response.data.dtRejeicao;

         if (situacao === 1) { /* situacao é do tipo number */
           this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
         } else {
           this.$toasted.success(this.$t("messages.cadastro.aprovadoComSucesso"));
         }
       });
   },
   validaBalanco(situacao, motivo, tipo) {
     this.$store.commit("setCalcLimpa", {
       setCalcLimpa: 2
     });
     //metodo para validar o balanco
     const model = Object.assign(
       {},
       this.modelQualificacao.balancoFinanceiro
     );
     model.numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "");
     if (tipo === "b") {   
       model.arquivoUploadSituacao = situacao;
       model.idMotivoIndeferimentoArquivo = motivo;
       model.arquivoUploadSituacao02 = null;
       model.idMotivoIndeferimentoArquivo02 = null;
     } else {
       model.arquivoUploadSituacao = null;
       model.idMotivoIndeferimentoArquivo = null;
       model.arquivoUploadSituacao02 = situacao;
       model.idMotivoIndeferimentoArquivo02 = motivo;
     }

     qualificacaoEconomicaService
       .aprovarRejeitarBalanco(model)
       .then(response => { /*resposta do servico*/
         this.model.balancoFinanceiro.arquivoUploadSituacao = response.data.arquivoUploadSituacao;
         this.model.balancoFinanceiro.idMotivoIndeferimentoArquivo = response.data.idMotivoIndeferimentoArquivo;
         this.model.balancoFinanceiro.dtRejeicao = response.data.dtRejeicao;
         this.model.balancoFinanceiro.anoBalanco = response.data.anoBalanco;
         this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao = response.data.arquivoUploadSituacao;
         this.modelQualificacao.balancoFinanceiro.idMotivoIndeferimentoArquivo = response.data.idMotivoIndeferimentoArquivo;
         this.modelQualificacao.balancoFinanceiro.dtRejeicao = response.data.dtRejeicao;

         this.model.balancoFinanceiro.arquivoUploadSituacao02 = response.data.arquivoUploadSituacao02;
         this.model.balancoFinanceiro.idMotivoIndeferimentoArquivo02 = response.data.idMotivoIndeferimentoArquivo02;
         this.model.balancoFinanceiro.dtRejeicao02 = response.data.dtRejeicao02;
         this.model.balancoFinanceiro.anoBalanco2 = response.data.anoBalanco2;
         this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao02 = response.data.arquivoUploadSituacao02;
         this.modelQualificacao.balancoFinanceiro.idMotivoIndeferimentoArquivo02 = response.data.idMotivoIndeferimentoArquivo02;
         this.modelQualificacao.balancoFinanceiro.dtRejeicao02 = response.data.dtRejeicao02;

         if (situacao === 1) { /* situacao é do tipo number */
           this.$toasted.success(this.$t("messages.cadastro.rejeitadoComSucesso"));
         } else {
           this.$toasted.success(this.$t("messages.cadastro.aprovadoComSucesso"));
         }
       });
   },
   validaDataValidade(v) {
     if (v < this.modelQualificacao.balancoFinanceiro.dtBalanco && v) {
       return false;
     } else {
       return true;
     }
   },

   //Remove validacao de documento caso um campo seja alterado 
   alteracaoValorCampoConcordata() {
     this.model.concordataFalencia.arquivoUploadSituacao = null;
     this.model.concordataFalencia.dtRejeicao = null;
     this.model.concordataFalencia.idMotivoIndeferimentoArquivo = null;
     this.modelQualificacao.concordataFalencia.arquivoUploadSituacao = null;
     this.modelQualificacao.concordataFalencia.dtRejeicao = null;
     this.modelQualificacao.concordataFalencia.idMotivoIndeferimentoArquivo = null;
   },
   alteracaoValorCampoBalanco() {
     // Ticket #188855 - Ajustes Data de Vencimento Balanços 01 e 02
     const dateStr = this.modelQualificacao.balancoFinanceiro.dtBalanco;
     const year = dateStr.split('-')[0];
     // Fim Ticket #188855 - Ajustes Data de Vencimento Balanços 01 e 02
     
     this.model.balancoFinanceiro.arquivoUploadSituacao = null;
     this.model.balancoFinanceiro.dtRejeicao = null;
     this.model.balancoFinanceiro.idMotivoIndeferimentoArquivo = null;
     this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao = null;
     this.model.balancoFinanceiro.arquivoUploadSituacao = null;
     this.modelQualificacao.balancoFinanceiro.dtRejeicao = null;
     this.modelQualificacao.balancoFinanceiro.idMotivoIndeferimentoArquivo = null;
     
     const dtBalancoInput = this.$refs.dtBalanco.date;
    
    
     

   },
   alteracaoValorCampoBalanco2() {
  
     this.model.balancoFinanceiro.arquivoUploadSituacao02 = null;
     this.model.balancoFinanceiro.dtRejeicao02 = null;
     this.model.balancoFinanceiro.idMotivoIndeferimentoArquivo02 = null;
     
     this.modelQualificacao.balancoFinanceiro.arquivoUploadSituacao02 = null;
      this.model.balancoFinanceiro.arquivoUploadSituacao02 = null;
     this.modelQualificacao.balancoFinanceiro.dtRejeicao02 = null;
     this.modelQualificacao.balancoFinanceiro.idMotivoIndeferimentoArquivo02 = null;
    
   }
 }
};



</script>
<style scoped> /*CSS especifico do componente*/
.divToolTip {
 width: 30px !important;
 float: left;
 margin: 20px 0 0 -20px;
}

.titH1 {
 text-transform: uppercase;
 padding-top: 20px;
 float: left;
}

.titBalanco {
 width: 130px !important;
}

.v-list__tile {
  height: 60px;
}

.v-list__tile__sub-title {
  font-size: 11px;
}

.v-list__tile--active {
  font-family: gothambold;
}

.v-list__tile--active .v-list__tile__title {
  color: #333;
}

.theme--light.v-subheader {
  font-family: gothambold;
  color: #10618b;
}

.tipoItem {
  padding-top: 0;
}

.boxConcordata .v-toolbar__title {
  font-size: 13px !important;
  color: #10618b;
  width: 100%;
  text-align: right;
}

.boxIndices .v-toolbar__title>strong {
  display: block;
}

:host /deep/ .d-flex {
 flex: 0 1 auto !important;
 -ms-flex: unset !important;
}

.custom-flex {
 flex: 0 1 auto !important;
 -ms-flex: unset !important;
}

.custom-flex h1 {
 flex: 0 1 auto !important;
 -ms-flex: unset !important;
}

.boxIndices .v-toolbar__content {
  height: 52px !important;
}

.boxShadow .v-card__title .v-btn {
  margin-top: -10px;
}

.balanco-label {
 margin-right: 8px; /* Ajuste a margem direita conforme necessário */
}


.boxConcordata .v-toolbar__title {
  overflow: inherit !important;
}

.boxInfoDoc {
  width: 400px;
  font-size: 11px;
}

.positionBullet {
  margin: 0 0 0 5px;
  cursor: pointer;
}
</style>
<style>
.hintClass span.tooltipHinttext {
 right: 0 !important;
}
</style>